// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border: 1px solid var(--ion-item-border-color);
}
ion-item ion-select {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-fields/custom-fields.component.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;AACJ;AAAI;EACI,WAAA;AAER","sourcesContent":["ion-item {\n    border: 1px solid var(--ion-item-border-color);\n    ion-select {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
